import React from 'react';
import '../styles.css';
import * as f from '../logic';
import { connect } from 'react-redux';
import _ from 'lodash';

function Intro(props) {
  const { level } = props;
  const secs = f.levelInfo(level).time;

  return (
    <div style={{ display: 'grid', gridArea: '1/1', alignContent: 'center', maxWidth: '400px' }}>
      <div className="ms-intro">
        <div style={{ marginBottom: '15px' }}>Congratulations!</div>
        <Item content={`You have cleared •$${level - 1}• level.`} />
        <Item content={`Next level: •$${level}•`} />
        <Item
          content={`From now on you have •${secs}• seconds to make a move. If you miss the •${secs}• seconds window, a random choice move will be made for you.`}
        />
        <div className="ms-start" onClick={props.onContinue}>
          CONTINUE
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Intro);

function Item(props) {
  const text = props.content.toString();
  const runs = _.split(text, '•');

  return (
    <div className="ms-intro-item">
      <span style={{ margin: '0px 10px 0 0' }}>•</span>
      <div>
        {_.map(runs, (run, i) => {
          const levelName = run.startsWith('$');
          const color = i % 2 && !levelName ? 'lime' : 'white';
          const textShadow = levelName ? '0 0 transparent' : '1px 1px black';
          const levelInfo = levelName ? f.levelInfo(run.slice(1)) : null;
          const background = levelInfo ? levelInfo.color : null;
          const padding = levelName ? '2px 7px' : '';

          if (levelName) {
            run = levelInfo.name;
          }

          return (
            <span key={i} style={{ color, textShadow, background, padding }}>
              {run}
            </span>
          );
        })}
      </div>
    </div>
  );
}
